import { render, staticRenderFns } from "./superhot-vivaincontri.vue?vue&type=template&id=3a87ef27&"
import script from "./superhot-vivaincontri.vue?vue&type=script&lang=js&"
export * from "./superhot-vivaincontri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a87ef27')) {
      api.createRecord('3a87ef27', component.options)
    } else {
      api.reload('3a87ef27', component.options)
    }
    module.hot.accept("./superhot-vivaincontri.vue?vue&type=template&id=3a87ef27&", function () {
      api.rerender('3a87ef27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/superhot-vivaincontri.vue"
export default component.exports